var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"557f6f62b26aa4cdc9aff3b2504b0ccfb427ec93"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["fluffy-insurance-react@fluffy"]={id:"557f6f62b26aa4cdc9aff3b2504b0ccfb427ec93"};
      